import { Stack } from '@mui/material';
import { HXCIcon, Icons } from '../../HXCIcon';

export const DropDownIcon = ({ className }: { className: string }) => {
  return (
    <Stack className={className} sx={{ top: `7px !important` }}>
      <HXCIcon name={Icons.DropdownSm} color={'darkGray'} />
    </Stack>
  );
};
